import React from "react";
import IOSSwitch from "./form-switch.style";

export const OcFormSwitch = (props: any) => {
  return <IOSSwitch {...props} />;
};

export default OcFormSwitch;
